import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable indent */
import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useStyles } from './style';

const Alert = props => /*#__PURE__*/React.createElement(MuiAlert, _extends({
  elevation: 6,
  variant: "filled"
}, props));

export const APIAlert = ({
  errorInfo,
  handleClose,
  persistentError
}) => {
  const classes = useStyles();
  const alertClass = errorInfo && (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.severity) === 'error' ? {
    message: classes.message
  } : undefined;
  return errorInfo ? /*#__PURE__*/React.createElement(Snackbar, {
    open: !!errorInfo,
    autoHideDuration: persistentError ? undefined : 3000,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(Alert, {
    onClose: handleClose,
    severity: errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.severity,
    classes: alertClass
  }, errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.text)) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default APIAlert;